import React from 'react';
import {
  Button,
  Popover,
  MenuItem,
  MenuList,
  Divider,
  Tooltip,
  CircularProgress
} from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

function ButtonDropdown(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openTooltip, setOpenTooltip] = React.useState(false);
  const open = Boolean(anchorEl);
  const { classes, title, tooltip, onSelect, items, buttonWidth, menuWidth, style, disabled, size, openCallback, isLoading } = props;
  function handleOpen(e) {
    setAnchorEl(e.currentTarget);
    setOpenTooltip(false);
    if (openCallback) {
      openCallback();
    }
  }

  function handleClose() {
    setAnchorEl(null);
  }

  function handleMenuItemClick(item) {
    onSelect(item);
    handleClose();
  }

  return (
    <Tooltip title={tooltip || ''} open={openTooltip}>
      <div
        className={classNames(classes.container, props.className)}
        onMouseEnter={() => setOpenTooltip(true)}
        onMouseLeave={() => setOpenTooltip(false)}
      >
        <Button
          className={classNames(classes.buttonWithIcon, size === 'tiny' && classes.tinyButton)}
          variant='contained'
          color='primary'
          size={size === 'tiny' ? 'small' : size}
          style={{
            ...style,
            width: buttonWidth
          }}
          onClick={handleOpen}
          disabled={disabled}
        >
          <span>{title}</span>
          <ArrowDropDownIcon className={classes.buttonRightIcon} style={size !== 'tiny' ? { marginLeft: 4 } : null} />
        </Button>
        <Popover
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          {isLoading ?
          <div style={{ padding: 4, display: 'flex' }}>
            <CircularProgress color="primary" size={20} />
          </div>
          
          :
          <MenuList style={{ width: menuWidth }}>
            {items.map((item) => {
              if (!item) return null;
              return (
                item.separator
                  ? <Divider key={'divider'} />
                  : <MenuItem
                    key={item.id ?? item.text}
                    onClick={() => handleMenuItemClick(item)}
                    disabled={item.disabled}
                  >
                    {item.text}
                  </MenuItem>
              )
            })}
          </MenuList>
          }
        </Popover>
      </div>
    </Tooltip>
  );
}

const styles = theme => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  buttonWithIcon: {
    margin: theme.spacing(1)
  },
  buttonRightIcon: {
    fontSize: 20,
  },
  tinyButton: {
    padding: '0 2px 0 6px'
  }
});

export default withStyles(styles)(ButtonDropdown);
